<template>
  <VideoPlayer :youtube-link="link" />
</template>

<script>
import VideoPlayer from '~/components/common/VideoPlayer/VideoPlayer';

export default {
  name: 'WarRoomPostContentYoutube',
  components: {
    VideoPlayer,
  },
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    link() {
      return this.content.link_url;
    },
  },
};
</script>
